import { render, staticRenderFns } from "./orderSuccess.vue?vue&type=template&id=0ebbb82b&scoped=true&"
import script from "./orderSuccess.vue?vue&type=script&lang=js&"
export * from "./orderSuccess.vue?vue&type=script&lang=js&"
import style0 from "./orderSuccess.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderSuccess.vue?vue&type=style&index=1&id=0ebbb82b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebbb82b",
  null
  
)

export default component.exports